export enum Namespaces {
  BotDesigner = 'bd',
  CareCampaigns = 'cc',
  ChatWidgets = 'cw',
  Faq = 'faq',
  GroupSettings = 'gs',
  OncallSchedules = 'os',
  PatientChat = 'pc',
  QuickForms = 'qf',
  Reports = 'rp',
  SelfScheduler = 'ss',
  VirtualConversations = 'vc',
  VisitPath = 'vp',
  UserSettings = 'us',
  EntityPreview = 'ep',
}
